export default __webpack_public_path__ + "static/media/1776.23ef05b8.png";